export default "__VITE_ASSET__BLoIktPk__"